<template>
    <div>
        <div class="row justify-content-center">
            <div class="col-11 text-start">
                <slot name="logo">
                    <logo />
                </slot>
            </div>
            <div class="col-11">
                <slot name="main"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import Logo from "@/components/Logo.vue";

export default {
    name: "manager-layout",
    data: function () {
        return {};
    },
    components: { Logo },
};
</script>

<style lang="scss">

</style>
